export default __webpack_public_path__ + "static/media/logo-telesales.873c4a52.png";